import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X, Linkedin, Instagram, MessageCircle } from 'lucide-react';
import { FaPinterest } from 'react-icons/fa';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const socialLinks = [
    { icon: Linkedin, url: 'https://www.linkedin.com/in/oyetunde-ibrahim-b10355343', label: 'LinkedIn' },
    { icon: MessageCircle, url: 'https://wa.me/message/R2S5SGLV5TP5O1', label: 'WhatsApp' },
    { icon: Instagram, url: 'https://www.instagram.com/kheenspro', label: 'Instagram' },
    { icon: FaPinterest, url: 'https://pin.it/41roogNcw', label: 'Pinterest' }
  ];

  return (
    <motion.header 
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="header-nav"
    >
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: '100%' }}>
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link to="/">
            <img 
              src="/logo.png" 
              alt="Kheenspro Logo" 
              className="logo"
            />
          </Link>
        </motion.div>

        <motion.nav 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}
        >
          {[
            { path: '/', label: 'Home' },
            { path: '/services', label: 'Services' },
            { path: '/about', label: 'About' },
            { path: '/blog', label: 'Blog' },
            { path: '/contact', label: 'Contact' }
          ].map((item, index) => (
            <motion.div
              key={item.path}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
              whileHover={{ y: -3 }}
            >
              <Link 
                to={item.path} 
                className={isActive(item.path) ? 'active' : ''} 
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
            </motion.div>
          ))}
          
          <div className="social-links" style={{ display: 'flex', gap: '0.75rem', marginTop: mobileMenuOpen ? '1rem' : '0' }}>
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label={social.label}
                  style={{ width: '36px', height: '36px' }}
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3, delay: 0.8 + index * 0.1 }}
                >
                  <Icon size={18} />
                </motion.a>
              );
            })}
          </div>
        </motion.nav>

        <motion.button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </motion.button>
      </div>
    </motion.header>
  );
};

export default Header;
